import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {filterHTML, filterResource} from "../helpers/filters";

interface Data {
    paragraphById: {
        fieldTextDemo: Array<{
            value: string;
            format: string;
            processed: string;
        }>;
        fieldImageDemoMedia: Array<{
            entity: Array<{
                fieldMediaImage: Array<{
                    width: string;
                    height: string;
                    url: string;
                    targetId: string;
                    alt: string;
                    title: string;
                }>;
            }>;
        }>;
    }
}

class ImageTextQuery extends Query<Data, {id: string}> {}

const GET_IMAGE_TEXT = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphImageText {
          fieldTextDemo {
            value
            format
            processed
          }
          fieldImageDemoMedia {
              entity {
                ... on MediaImage {
                  fieldMediaImage {
                    width
                    height
                    url
                    alt
                    title
                  }
                }
              }
          }
        }
      }
    }
  }
}
`;

const ImageText = ({id, markComponentLoadedAs}) => (
    <ImageTextQuery asyncMode query={GET_IMAGE_TEXT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            markComponentLoadedAs(id, true);

            return (
                <div className="imageText">

                    {field.fieldImageDemoMedia && field.fieldImageDemoMedia.entity && field.fieldImageDemoMedia.entity.fieldMediaImage && field.fieldImageDemoMedia.entity.fieldMediaImage.url && (
                        <div className="imageText__image">
                            <img src={filterResource(field.fieldImageDemoMedia.entity.fieldMediaImage.url)} alt={field.fieldImageDemoMedia.entity.fieldMediaImage.alt}/>
                        </div>
                    )}

                    {field.fieldTextDemo && field.fieldTextDemo.value && (
                        // eslint-disable-next-line react/no-danger
                        <div className="imageText__content" dangerouslySetInnerHTML={{__html: filterHTML(field.fieldTextDemo.value)}} />
                    )}

                </div>
            );
        }}
    </ImageTextQuery>
);

ImageText.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    handleLoadedComponents: PropTypes.func.isRequired
};

export default ImageText;



// WEBPACK FOOTER //
// ./frontend/components/ImageText.jsx